/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AccountId/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AccountId({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AccountId"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let providerAccountAccountIdValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'account_id',
})
  return (<React.Fragment
>
<div
  data-testid="AccountId.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-cLwbO': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 width={130}
 color={dtColorsNeutral500}
 text="Account ID"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 width={200}
 data="provider_account.account_id"
 text={providerAccountAccountIdValueData}
/>
</div>
{children}
</React.Fragment>)
}